var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.rootClasses],
      on: {
        transitionstart: _vm.onTranitionStart,
        transitionend: _vm.onTransitionEnd
      }
    },
    [
      _c("div", { staticClass: "lateral-menu--logo grid grid__base" }, [
        _c("div", { staticClass: "grid--container" }, [
          _c("div", { staticClass: "grid--row" }, [
            _c(
              "div",
              { staticClass: "grid--col" },
              [_c("app-logo", _vm._b({}, "app-logo", _vm.home.content, false))],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lateral-menu--content" }, [
        _c(
          "div",
          { staticClass: "lateral-menu--main-menu" },
          [
            _c("main-menu", {
              attrs: { facets: ["vertical"], children: _vm.menuItems }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lateral-menu--languages" },
          [
            _c("language-menu", {
              attrs: {
                facets: ["lateral-menu"],
                children: _vm.language.children
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f94c878", { render: render, staticRenderFns: staticRenderFns })
  }
}